import React from "react";
import { TopbarButton } from "./BasicTopbarComponents";

const TopbarReferral = () => {
  //   const openReferral = () => {
  //     if (window.cello) {
  //       window.cello.open();
  //     }
  //   };
  return (
    // <div>
    //   <i className="fi fi-rr-referral-user"></i>
    //   <button
    //     //onClick={openReferral}
    //     type="button"
    //     id="celloId"
    //   >
    //     Refer Friends
    //   </button>
    // </div>
    <TopbarButton type="button" id="celloId">
      <i className="fi fi-rr-gift"></i>
    </TopbarButton>
  );
};

export default TopbarReferral;
